
class Token {
  private static instance: Token;
  private TOKEN_KEY = 'smart-agent-token';
  private storage: Storage = localStorage;

  private constructor() {}

  public static getInstance(): Token {
    if (!Token.instance) {
      Token.instance = new Token();
    }
    return Token.instance;
  }

  public setStorageType(type: 'localStorage' | 'sessionStorage', key?: string): void {
    this.storage = type === 'localStorage' ? localStorage : sessionStorage;
    if (key) {
      this.TOKEN_KEY = key;
    }
  }

  public getToken(): string | null {
    return this.storage.getItem(this.TOKEN_KEY);
  }

  public setToken(token: string): void {
    this.storage.setItem(this.TOKEN_KEY, token);
  }

  public removeToken(): void {
    this.storage.removeItem(this.TOKEN_KEY);
  }
}

export const tokenManager = Token.getInstance();
export default Token;
